import * as React from "react";
import axios, { AxiosResponse } from "axios";

interface ActionsFecthState {
  loading: boolean;
  actions: Insite.API.Action[];
  error: any;
}

export function useFetchActions(actionIds?: string[]) {
  const [actionsFetch, setActionsFetch] = React.useState<ActionsFecthState>({
    loading: false,
    actions: [],
    error: undefined,
  });

  React.useEffect(
    function getActions() {
      // Nothing to fetch yet -- the modal mounts (hidden) before a row is
      // clicked, so `actionIds` starts out empty.
      if (!actionIds || actionIds.length === 0) {
        return;
      }

      setActionsFetch((prev) => ({
        ...prev,
        loading: true,
      }));

      const fetchActions = async () => {
        try {
          // TODO: Endpoint payload could change in order to make it work from comfort view.
          const { data }: AxiosResponse<Insite.API.Action[]> = await axios.post(
            "/issues/search",
            {
              ids: actionIds,
            }
          );

          setActionsFetch({
            actions: data,
            loading: false,
            error: undefined,
          });
        } catch (error) {
          setActionsFetch((prev) => ({
            ...prev,
            loading: false,
            error,
          }));
          console.error(error);
        }
      };
      void fetchActions();
    },
    [actionIds]
  );

  return actionsFetch;
}
